import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface YearRangeToggleProps {
    className?: string;
    isRangeMode: boolean;
    onToggle: () => void;
    testId: string;
}

export const YearRangeToggle: React.FC<YearRangeToggleProps> = ({ className, isRangeMode, onToggle, testId }) => {
    const { t } = useTranslation();

    return (
        <button
            type="button"
            className={classNames("link textNoWrap", className)}
            onClick={onToggle}
            data-testid={testId}
        >
            {isRangeMode ? t("yearRange.useSingleYear") : t("yearRange.useRange")}
        </button>
    );
};
